/* eslint-disable linebreak-style */
import React, { ReactElement } from 'react';
import { Form } from 'react-bootstrap';
import { getIn, FormikProps } from 'formik';
// import Creatable from 'react-select/creatable';
import ReactSelect, { OptionsType, OptionTypeBase } from 'react-select';
import { isArray, isPlainObject } from 'lodash';

type CreatableSelectInput = {
  formikProps: FormikProps<any>
  fieldName: string,
  visibleName: string,
  isMulti?: boolean,
  isSearchable?:boolean,
  extraClassValues?: string,
  placeholder?: string,
  formText?: string,
  possibleValues: OptionsType<any> | Array<any> | Object,
  onChangeCallback?:
    (val: any)=>void,
  withNullOption?: boolean,
}
const ReactSelectField: React.FC<CreatableSelectInput> = (
  props: CreatableSelectInput,
): ReactElement => {
  const {
    fieldName,
    visibleName,
    extraClassValues = '',
    onChangeCallback,
    formText = '',
    formikProps,
    possibleValues,
    isMulti = false,
    isSearchable = true,
    withNullOption = true,
  } = props;
  const {
    placeholder = visibleName,
  } = props;
  const {
    handleBlur,
    values,
    errors,
    handleChange,
    touched,
    setFieldTouched,
  } = formikProps;
  const setValues: Array<OptionTypeBase> = [];
  const setPossibleValues: Array<OptionTypeBase> = [];
  if (withNullOption && !isMulti) {
    setPossibleValues.push({ label: '--none--', value: null });
  }
  const labelValMappings = {};
  /* @ts-ignore */
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const valIndex in possibleValues) {
    const val = possibleValues[valIndex];
    if (isPlainObject(val) && val.label !== undefined && val.value !== undefined) {
      setPossibleValues.push(val);
      labelValMappings[val.value] = val.label;
    } else {
      setPossibleValues.push({ label: val, value: val });
      labelValMappings[val] = val;
    }
  }

  let valArray = getIn(values, fieldName);
  if (!isArray(valArray) && valArray) {
    valArray = [valArray];
  }
  // Here we attempt to map the values we see in the array field to labels
  // We gathered from 'possible values'
  // We fall back to labeling options with simple values if our label mapper has noting for them
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const index in valArray) {
    let label;
    let value;
    const val = valArray[index];

    // If `val` is an object with `label` and `value` properties, use them. Otherwise,
    // generate a label/value pair manually
    if (isPlainObject(val) && val.label !== undefined && val.value !== undefined) {
      label = val.label;
      value = val.value;
    } else {
      label = (labelValMappings[valArray[index]] !== undefined)
        ? labelValMappings[valArray[index]] : valArray[index];
      value = val;
    }

    setValues.push({ label: `${label}`, value });
  }

  return (
    <Form.Group controlId={fieldName} className={extraClassValues}>
      <Form.Label>{visibleName}</Form.Label>
      <ReactSelect
        value={setValues}
        isSearchable={isSearchable}
        isMulti={isMulti}
        options={setPossibleValues}
        // selectOption={}
        isInvalid={getIn(touched, fieldName) && getIn(errors, fieldName)}
        className={(getIn(touched, fieldName) && getIn(errors, fieldName)) ? 'is-invalid' : ''}
        onFocus={(e) => setFieldTouched(fieldName)}
        onBlur={handleBlur}
        onChange={(e) => {
          if (!e) return;
          let val = e.valueOf();
          let ret: any = null;
          // if isMulti is selected, the value must always be an array
          if (!isArray(val) && isMulti) {
            // @ts-ignore
            val = [val.value];
          } else if (isMulti) {
            ret = [];
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            for (const index in val) {
              // @ts-ignore
              ret.push(val[index].value);
            }
          } else {
            // @ts-ignore
            ret = val.value;
          }
          // we manually specify target and value for handleChange since
          // we have to programmatically manipulate the value
          handleChange({
            target: { name: fieldName, value: ret },
          });
          if (onChangeCallback) {
            onChangeCallback(ret);
          }
        }}
        placeholder={placeholder}
      />
      <Form.Text className="text-muted">
        {formText}
      </Form.Text>
      <Form.Control.Feedback type="invalid">
        {getIn(errors, fieldName)}
      </Form.Control.Feedback>
    </Form.Group>
  );
};
export default ReactSelectField;
